import "./StoreOrderItemsComponent.scss";
import {IComponentOptions, IOnChanges, IOnChangesObject} from "angular";
import {StoreOrderItemLine} from "./models/StoreOrderItemLine";
import {Optional} from "../../../../js/util/Optional";
import {sum} from "../../../../js/util/UtilFunctions";

export const StoreOrderItems = "tfStoreOrderItems";

export function storeOrderItems(parentDir: string): IComponentOptions {
    return {
        templateUrl: `${parentDir}/order-items/StoreOrderItemsComponent.html`,
        bindings: {
            items: "<"
        },
        controllerAs: "ctrl",
        controller: StoreOrderItemsComponentController
    };
}

export class StoreOrderItemsComponentController implements IOnChanges {

    public items: Array<StoreOrderItemLine>;

    public total: number;

    public $onChanges(changes: IOnChangesObject): void {
        this.total = Optional.of(this.items)
                             .orElse([])
                             .map((item) => item.price)
                             .reduce(sum, 0);
    }
}
